import { useEffect, useState, useRef } from "react";
import { Accordion, Card } from "react-bootstrap";
import Sidebar from "../Sidebar/sidebar";
import TopNavbar from "../Navabr/navbar";
import "./companies.css";
import {list, sectorList} from '../../../controllers/company/accounts';
import { FaTh, FaServer, FaChevronDown } from "react-icons/fa";
import { Skeleton } from "antd";
import { Link, useLocation } from "react-router-dom";

import SelectPopUp from '../Compinies/Popup';
import { NOIMAGE } from "../../../config/constants";
import { createImageFromInitials, getRandomColor } from "../../../controllers/common";
import { interestList } from "../../../controllers/interest/interestController";

const Companies = () => {
  const targetRef = useRef();
  const location = useLocation();
  const interestedCompanyList = JSON.parse(sessionStorage.getItem('INTEREST-DATA'));
  const [activeAccordion, setActiveAccordion] = useState(0);
  const handleAccordionClick = (eventKey) => {
    setActiveAccordion(activeAccordion === eventKey ? null : eventKey);
  };
  const [dataView, setDataView]= useState('grid');
  const [isSelectShow, setIsSelectShow]= useState(false);
  const handleIsSelectShow =() => setIsSelectShow(!isSelectShow);
  const [companyId, setCompanyId] = useState('');
  const handleSelect=(id)=>{ 
    setCompanyId(id);
    handleIsSelectShow();
  }

  const USERDATA = JSON.parse(sessionStorage.getItem('USER-INFO'));
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [TOTALCOUNT, setTotalCount] = useState();
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [searchText, setSearchText] = useState(location?.state?.company || "");
  const [isSearch, setIsSearch] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [companySector, setCompanySector] = useState([]);
  // const [selectedSector, setSelectedSector] = useState(location?.state?.sector || "");
  const [interest, setInterest] = useState('');

  // sector start
  const [selectedSectors, setSelectedSectors] = useState(
    location?.state?.sector ? [location.state.sector] : []
  );
  const [showSectorDropdown, setShowSectorDropdown] = useState(false);
  const sectorDropdownRef = useRef(null);
  
  const toggleSector = (sector) => {
    setSelectedSectors((prev) =>
      prev.includes(sector) ? prev.filter((s) => s !== sector) : [...prev, sector]
    );
  };
  
  // close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sectorDropdownRef.current && !sectorDropdownRef.current.contains(e.target)) {
        setShowSectorDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // sector end


  const toggleExpand = (index) => {
    setExpanded((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const handleSearchChnage = (e) =>{
    const {value} = e.target;
    if(e.key === 'Enter'){
      handleSearch(e);
    }else{
      setSearchText(value);
    }
  }
  const handleSearch = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    // setSelectedSector(formData.get('company_sector') || "");
    // if(searchText.length > 0){
      setListData([]);
      setSkip(0);
      setIsSearch(!isSearch);
    // }
  }

  const getList = async () =>{
    try {
      const options = {
        type: "",
        condition: { 
          ...((searchText && searchText !== "") && {
            $or : [
              { company_name :  { $regex: searchText, $options: "i" } },
              { company_founder_name : { $regex: searchText, $options: "i" } },
              { company_stage : { $regex: searchText, $options: "i" } },
            ],
          }),
          // ...(selectedSector && { company_sector :  { $regex: selectedSector, $options: "i" } }),
          ...(selectedSectors.length > 0 && { company_sector: { $in: selectedSectors } }),
          status: 'A' 
        },
        select: {},
        sort: { _id: -1 },
        // skip: SKIP ? SKIP : 0,
        // limit: LIMIT ? LIMIT : 10,
      }
      const res = await list(options);
      if(res.status === true){
        setListData(res.result);
        if(SKIP === 0){
          setTotalPages(res?.count || 0);
          setTotalCount(res?.count || 0);
        }
      }
    } catch (error) {
      
    }
  }

  const loadMoreData = async () => {
    try {
      const skip = ALLLISTDATA.length;
      const options = {
        type: "",
        condition: { 
          ...(searchText?{
            $or : [
              { company_name :  { $regex: searchText, $options: "i" } },
              { company_founder_name : { $regex: searchText, $options: "i" } },
              { company_stage : { $regex: searchText, $options: "i" } },
              { company_sector : { $regex: searchText, $options: "i" } }
            ],
          }:null),
          status: 'A'
        },
        select: {},
        sort: { _id: -1 },
        skip: skip ? skip : 0,
        limit: 10,
      }
      const res = await list(options);
      if(res?.status === true || res?.result?.length > 0){
        setListData((prev) => [...prev, ...res.result]);
      }
    } catch (error) {
      
    }
  }

  const getCompanySector = async () => {
    try {
      const res = await sectorList();
      if(res.status === true){
        setCompanySector(res.result);
      }
    } catch (error) {
      
    }
  }

  const getInterest = async () => {
    try {
      const options = {
        condition : { 
          investor_data : USERDATA?.firm?._id,
          investor_users : {$ne : USERDATA?._id},
          // ...(showStatus?{status : showStatus}:null)
        },
        select : {company_data : true}
      }
      const res = await interestList(options);

      if(res.status === true || res.status === true){
        const idList = await Promise.all(
          res.result.map(async items => {
            return items?.company_data?._id; // async function
          })
        );
        setInterest(idList);
      }

    } catch (error) {
    }
  }

  const getIdCount = async (id = "") => {
    return interest.filter(item => item === id).length;
  }

  

  useEffect(()=>{
    getInterest();
    getList();
    getCompanySector();
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = "Chiratae Ventures | Spotlight | Companies list";
  },[isSearch]);

  useEffect(() => {
    setListData([]);
    setSkip(0);
    getList();
  }, [selectedSectors]);



  const lastItemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          if(TOTALCOUNT !== ALLLISTDATA.length){
            // loadMoreData();
          }
          // Optionally disconnect the observer if you only need the alert once
          observer.disconnect();
        }
      },
      { threshold: 1.0 } // Adjust threshold as needed
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [ALLLISTDATA,lastItemRef]);

  return (
    <>
      <TopNavbar></TopNavbar>
      <div className="main-wrapper" ref={targetRef}>
        <div>
          <Sidebar></Sidebar>
        </div>
        <div className="main_contant">
          <div className="container-fluid all_page_for_top_heading">
            <h2 className=" text-uppercase all_heading">Companies {searchText}</h2>
          </div>
          <div className="container-fluid all_page_for_top_heading">
            <form onSubmit={handleSearch}>
              <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3">
                  {/* <select name="company_sector" id="company_sector" className="form-control all_input">
                    <option value={``}>All Sector</option>
                    {(companySector && companySector?.length > 0) && (companySector.map((items, key)=>(
                      <option value={items} selected={selectedSector === items} >{items}</option>
                    )))}
                  </select> */}
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <div className="multi-select-wrapper" ref={sectorDropdownRef} style={{"width": "250px"}}>
                      <div
                        className="form-control all_input multi-select-toggle"
                        onClick={() => setShowSectorDropdown((prev) => !prev)}
                      >
                        {selectedSectors.length === 0
                          ? "All Sector"
                          : selectedSectors.length <= 2
                          ? selectedSectors.join(", ")
                          : `${selectedSectors.length} sectors selected`}
                        {/* <span className="ms-2"></span> */}
                        <FaChevronDown
                          className="ms-2"
                          style={{
                            fontSize: "12px",
                            transition: "transform 0.2s ease",
                            transform: showSectorDropdown ? "rotate(180deg)" : "rotate(0deg)",
                          }}
                        />
                      </div>
                        
                      {showSectorDropdown && (
                        <div className="multi-select-dropdown">
                          <label className="multi-select-option">
                            <input
                              type="checkbox"
                              checked={selectedSectors.length === 0}
                              onChange={() => setSelectedSectors([])}
                            />
                            All Sector
                          </label>
                          {(companySector && companySector.length > 0) &&
                            companySector.map((items, key) => (
                              <label className="multi-select-option" key={key}>
                                <input
                                  type="checkbox"
                                  checked={selectedSectors.includes(items)}
                                  onChange={() => toggleSector(items)}
                                />
                                {items}
                              </label>
                            ))}
                        </div>
                      )}
                    </div>

                    {/* show selected sectors as removable tags */}
                    {selectedSectors.length > 0 && (
                      <div className="selected_sector_tags">
                        {selectedSectors.map((sector, idx) => (
                          <span key={idx} className="sector_tag">
                            {sector}
                            <button type="button" onClick={() => toggleSector(sector)}>&times;</button>
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <input className="form-control all_input" type="text" name="search" id="search" onChange={handleSearchChnage} value={searchText} placeholder="Search interest..."/>
                </div>
                <div className="col-sm-2 col-md-2 col-lg-2">
                  <div className="profile_submit_btn">
                    <button type="submit" id="selected">Search</button>
                  </div>
                </div>
                <div className="col-sm-1 col-md-1 col-lg-1">
                  {dataView === 'table' ? (
                    <div title="Grid view"  className="profile_submit_btn" onClick={()=>setDataView('grid')}>
                      <button type="button" id="selected"><FaTh/></button>
                    </div>
                  ) : (
                    <div title="Table view" className="profile_submit_btn" onClick={()=>setDataView('table')}>
                      <button type="button" id="selected"><FaServer/></button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
          {ALLLISTDATA?.length > 0 ? 
            dataView ==='grid'?(
              ALLLISTDATA.map((items, index) => (
                <div key={index} className="container-fluid companies_section_main_div mb-3" ref={index === ALLLISTDATA.length - 1 ? lastItemRef : null}>
                  <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                    <div className="d-flex align-items-center companies_beep_cart_img">
                      {items?.company_image?(
                        <img
                          src={items?.company_image}
                          alt="Company Logo"
                          className="rounded"
                          style={{ marginRight: "10px" }}
                        />
                      ):(
                        <img
                          src={createImageFromInitials(100, `${items?.company_name.length > 8?items.company_name.substring(0,8)+'..':items?.company_name}`, '#ededed')}
                          alt="Company Logo"
                          className="rounded"
                          style={{ marginRight: "10px"}}
                        />
                      )}
                      <div>
                        <h6 className="mb-0" style={{ fontSize: "16px" }}>
                          {items?.company_name}
                        </h6>
                        <small className="text-muted">{items?.company_sector} </small>
                      </div>
                    </div>
                      <div style={{textAlign : "center"}}>
                        {(interest && interest?.length > 0) && (
                          <p className="interest_shown">{interest?.filter(item => item === items?._id).length > 0 && (`${interest.filter(item => item === items?._id).length} interest shown by other colleague`)}</p>
                        )}
                      </div>
                      {interestedCompanyList?.includes(items._id) ? (
                        <div className="started_in_mint_ago">
                          <button type="button">Interest sent</button>
                        </div>
                      ):(
                        <div className="profile_submit_btn">
                          <button type="button" onClick={()=>handleSelect(items._id)}>Select</button>
                        </div>
                      )}
                  </div>
                  <Accordion
                    activeKey={activeAccordion}
                    onSelect={handleAccordionClick}
                    className="companies_accrodian"
                  >
                    <Card style={{ border: "1px solid #e0e0e0", borderRadius: "8px" }} >
                      <Accordion.Item eventKey={index} className="company_accodian_item">
                        <Accordion.Header>
                          <span>About the company</span>
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ padding: "1rem" }}
                          className="companies_border_top"
                        >
                          <p> Company Name : <span>{items?.company_name}</span> </p>
                          {/* <p> Founder Name : <span>{items?.company_founder_name}</span> </p> */}
                          <p>
                            Founder(s) Name :{" "}
                            <span>
                              {items?.company_founder_name}
                              {items?.company_founder_name_2 && `, ${items.company_founder_name_2}`}
                              {items?.company_founder_name_3 && `, ${items.company_founder_name_3}`}
                            </span>
                          </p>
                          {/* <p> CEO Name : <span>{items?.company_ceo_name}</span> </p> */}
                          <p> Fund Raise Stage : <span> {items?.company_stage}</span> </p>
                          <p> Sector : <span>{items?.company_sector}</span> </p>
                          <p> Description :{" "}
                            {expanded[index]?
                            <span> 
                              {`${items?.company_description} `}
                            </span> : <span>
                            {items?.company_description !== 'undefined' ?`${items.company_description.slice(0, 175)}`:``}
                            </span>}
                            {items?.company_description?.length > 175 && (
                              <Link type="button" onClick={() => toggleExpand(index)}>
                                {expanded[index] ? 'Read less' : 'Read more'}
                              </Link>
                            )}
                          </p>
                          <p>Target Raise Size ($mm) : <span>{items?.target_raise_size}</span></p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Card>
                  </Accordion>
                </div>
              ))
            ):(
              <div id="content-wrapper" className="d-flex flex-column">
                <div className=" mb-4">
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                    <table
                        className="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                        >
                        <thead>
                          <tr>
                            <th>Sr. no.</th>
                            <th>Company</th>
                            <th>Founder(s)</th>
                            <th>Fund Raise Stage</th>
                            <th>Target Raise Size ($mm)</th>
                            <th>Sector</th>
                            <th>Colleague Interest</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {ALLLISTDATA.map((items, index) => (
                            <tr key={index} ref={index === ALLLISTDATA.length - 1 ? lastItemRef : null}>
                              <td>{index +1}</td>
                              <td className="admin_user_list_date"> {items?.company_name} </td>
                              {/* <td className="admin_user_list_date"> {items?.company_founder_name?`${items.company_founder_name} (Founder)`:`${items?.company_ceo_name}(CEO)`} </td> */}
                              <td className="admin_user_list_date">
                                {items?.company_founder_name}       
                                {items?.company_founder_name_2 && (
                                  <>
                                    <br />
                                    {items.company_founder_name_2}
                                  </>
                                )}
                                {items?.company_founder_name_3 && (
                                  <>
                                    <br />
                                    {items.company_founder_name_3}
                                  </>
                                )}
                              </td>
                              <td className="admin_user_list_date"> {items?.company_stage} </td>
                              <td className="admin_user_list_date"> {items?.target_raise_size} </td>
                              <td className="admin_user_list_date"> {items?.company_sector} </td>
                              <td className="admin_user_list_date"> 
                                {(interest && interest?.length > 0) && (
                                  interest?.filter(item => item === items?._id).length
                                )}
                              </td>
                              <td>
                                {interestedCompanyList?.includes(items._id) ? (
                                  <div className="started_in_mint_ago">
                                    <button type="button">Interest sent</button>
                                  </div>
                                ):(
                                  <div className="profile_submit_btn">
                                    <button type="button" onClick={()=>handleSelect(items._id)}>Select</button>
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ):(<>
            <div className="container-fluid companies_section_main_div mb-3">
              <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                <Skeleton avatar/>
              </div>
            </div>
            <div className="container-fluid companies_section_main_div mb-3">
              <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                <Skeleton avatar/>
              </div>
            </div>
            <div className="container-fluid companies_section_main_div mb-3">
              <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                <Skeleton avatar/>
              </div>
            </div>
          </>)}
        </div>
      </div>
      <SelectPopUp 
        show={isSelectShow} 
        handleIsSelectShow={handleIsSelectShow} 
        companyId={companyId}
        setCompanyId={setCompanyId} />
    </>
  );
}

export default Companies;
